/*----------------------------------
- DOMAINS RAIL RANGE
----------------------------------*/

/**
 * A range filter (Price, Length) as the mock draws it: the histogram of text-free bars, the track with its two
 * knobs, then the two bounds as small read-only fields (the kit `Field --sm`). The bars are decorative (no share is
 * known on this surface), so they are hidden from screen readers rather than labelled as a distribution.
 *
 * The track and either bound are a wall with the search on screen unchanged: no value was chosen, so no rule is named.
 */

/*----------------------------------
- DEPENDANCES
----------------------------------*/

import { Field } from '@uniquedomains/components/kit/field/Field';

import { DOMAINS_RAIL_COPY } from '@/client/catalogs/landing/domains/pageCopy';
import { RANGE_HISTOGRAM_BARS } from './railModel';

/*----------------------------------
- TYPES
----------------------------------*/

type DomainsRailRangeProps = {
    label: string;
    /** The catalog's unit: `$` leads the value, any other ("chars") follows it. */
    unit?: string;
    bounds: [string, string];
    onIntent: () => void;
};

/*----------------------------------
- CONSTANTS
----------------------------------*/

const HISTOGRAM = Array.from({ length: RANGE_HISTOGRAM_BARS }, (_, index) => index);

/*----------------------------------
- COMPONENT
----------------------------------*/

const DomainsRailRange = ({ label, unit, bounds, onIntent }: DomainsRailRangeProps) => {
    const leading = unit === '$' ? unit : undefined;
    const trailing = unit && unit !== '$' ? <span class="dm-unit">{unit}</span> : undefined;
    const bound = (value: string, which: string) => (
        <Field
            size="sm"
            value={value}
            readOnly
            label={`${which} ${label}`}
            icon={leading}
            action={trailing}
            onClick={onIntent}
        />
    );

    return (
        <>
            <div class="dm-hist" aria-hidden="true">
                {HISTOGRAM.map((bar) => <i key={bar} />)}
            </div>
            <button type="button" class="dm-range" aria-label={DOMAINS_RAIL_COPY.rangeTrack(label)} onClick={onIntent}>
                <i />
                <i />
            </button>
            <div class="dm-bounds">
                {bound(bounds[0], DOMAINS_RAIL_COPY.rangeMinimum)}
                <span>{DOMAINS_RAIL_COPY.rangeJoin}</span>
                {bound(bounds[1], DOMAINS_RAIL_COPY.rangeMaximum)}
            </div>
        </>
    );
};

export default DomainsRailRange;
